var timezoneDiv = document.querySelector(".webinar-banner__tag-timezone");

if (timezoneDiv) {
  var timezoneObj = timezoneDiv.dataset,
    month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    webinarDateDiv = document.querySelector(".webinar-banner__tag-timedate"),
    webinarTimeDiv = document.querySelector(".webinar-banner__tag-timezone");

  function formateDateNth(d) {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }

  if (timezoneObj.timezoneCode !== "" && webinarDateDiv && webinarTimeDiv) {
    var dateObj = new Date(timezoneObj.timezoneDatetime),
      clientTimeZone = dateObj.toString().match(/\(([A-Za-z\s].*)\)/)[1];

    //Get timezone short form
    var split_names = clientTimeZone.trim().split(" ");
    if (split_names.length > 1) {
      clientTimeZone = "";
      for (var i = 0; i < split_names.length; i++) {
        clientTimeZone += split_names[i].charAt(0);
      }
    }

    //Update Date
    webinarDateDiv.innerHTML =
      dateObj.getDate() +
      formateDateNth(dateObj.getDate()) +
      " " +
      month[dateObj.getMonth()] +
      " " +
      dateObj.getFullYear();

    //Update Time
    webinarTimeDiv.innerHTML = formatAMPM(dateObj) + " " + clientTimeZone;
  }
}
